import React from 'react';
import { CircularProgress, Backdrop } from '@material-ui/core';

const LoadingOverlay = () => {
  return (
    <Backdrop open={true} style={{ zIndex: 10000 }}>
      <CircularProgress />
    </Backdrop>
  );
};

export default LoadingOverlay;
